// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__rH8dC","container":"styles_container__3KTvJ","title":"styles_title__1USZT","wrapper":"styles_wrapper__3id1E","answer":"styles_answer__1IbHr"};